import MainCustomNavbar from "../../components/MainNavbar";
import image_0 from "../../assets/artist_pictures/ana/picture_0.webp";
import image_1 from "../../assets/artist_pictures/ana/picture_1.webp";
import image_3 from "../../assets/artist_pictures/ana/picture_3.webp";
import image_4 from "../../assets/artist_pictures/ana/picture_10.webp";
import frame_2 from "../../assets/artist_pictures/ana/frame_2.webp";
import frame_3 from "../../assets/artist_pictures/ana/frame_3.webp";
import frame_4 from "../../assets/artist_pictures/ana/frame_4.webp";
import frame_0 from "../../assets/artist_pictures/ana/frame_0.webp";
import frame_1 from "../../assets/artist_pictures/ana/frame_1.webp";
import old_house_2 from "../../assets/artist_pictures/ana/foto_antiga.webp";
import houses from "../../assets/components/houses.png";
import mosaico from "../../assets/artist_pictures/ana/picture_4.webp";
import rosa from "../../assets/artist_pictures/ana/picture_5.webp";
import jornal from "../../assets/artist_pictures/ana/picture_9.webp";
// import casa_video from '../../assets/videos/ana/casa.mp4'
// import mulher_video from '../../assets/videos/ana/mulher.mp4'
// import pandemia_video from '../../assets/videos/ana/pandemia.mp4'
// import criacao_video from '../../assets/videos/ana/criacao.mp4'
// import arte_video from '../../assets/videos/ana/performance.mp4'
import { Col, Container, Row } from "react-bootstrap";
import React, { useEffect } from "react";
// @ts-ignore
import marina from "../../assets/artist_pictures/marina/picture_2.webp";
// @ts-ignore
import ProjectColors from "../../Colors";
import Arrow from "../../assets/components/side_arrow.png";
import { useNavigate } from "react-router-dom";
import { Carousel } from "react-responsive-carousel";

import VideoPrefix from "../../VideoPrefix";

const casa_video = VideoPrefix + "ana/casa.mp4";
const mulher_video = VideoPrefix + "ana/mulher.mp4";
const pandemia_video = VideoPrefix + "ana/pandemia.mp4";
const criacao_video = VideoPrefix + "ana/criacao.mp4";
const arte_video = VideoPrefix + "ana/performance.mp4";

export default function ProfileAna() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <MainCustomNavbar activeTab1={true} />

      <main
        role="main"
        style={{
          backgroundColor: ProjectColors.getInstance().isHighContrast
            ? ProjectColors.getInstance().Black
            : ProjectColors.getInstance().White,
        }}
      >
        <Container
          fluid
          style={{
            height: "100%",
            padding: 0,
          }}
        >
          {/*<Row*/}
          {/*    className={'align-items-center px-3'} style={{height: '100vh', width: '100vw'}}>*/}

          {/*    <Col xs={{span: 12}} md={{span: 12}}>*/}

          {/*        <h1 style={{fontFamily: 'Active Regular', fontWeight: 'bold', textAlign: 'center'}}>Ana Luíza</h1>*/}

          {/*    </Col>*/}
          {/*</Row>*/}

          <div
            style={{
              background: "url(" + image_0 + ")",
              backgroundSize: "cover",
              height: "100%",
              width: "100%",
              backgroundAttachment: "fixed",
              backgroundPosition: "75%",
            }}
          >
            <div style={{ height: "20vh", width: "100vw" }}></div>
            <Row
              style={{
                height: "90vh",
                width: "100vw",
                padding: 0,
              }}
            ></Row>
          </div>

          {/*<Row className={'align-items-center px-3'} style={{marginTop: '10vh',}}>*/}

          {/*    <Col xs={{span: 12}} md={{span: 12}}*/}
          {/*        // className={'d-flex align-items-center'}*/}
          {/*    >*/}

          {/*    </Col>*/}
          {/*</Row>*/}

          <Row style={{ marginTop: 10 }} className={"px-2"}>
            <Col xs={{ span: 12 }} md={{ span: 12, offset: 0 }}>
              <h5
                style={{
                  fontFamily: "Gotham",
                  textAlign: "justify",
                  textAlignLast: "justify",
                  color: ProjectColors.getInstance().White,
                  backgroundColor: ProjectColors.getInstance().isHighContrast
                    ? ProjectColors.getInstance().Black
                    : ProjectColors.getInstance().Orange,
                  padding: "20px",
                }}
              >
                Ana Luíza Meneses é realizadora audiovisual e artista visual.
                Trabalha com cinema há sete anos, sendo cinco deles no
                departamento de câmera, onde já realizou diversos filmes de
                curta metragem e longa metragem, publicidades, videoclipes e
                videoartes. Colaborou em projetos para Netflix, TV Cultura,
                Intimus e Nowness. Atualmente se dedica ao ofício de direção de
                fotografia e à realização do curta metragem “Malu e a Máquina”
                (FSA). Como artista visual, participou da exposição coletiva
                “Baleias: mulheres artistas do DF”. É uma das autoras da 1ª
                Coleção de Minizines Sô Edições que faz parte da seleção de
                fotolivros de 2022 Revista Zum e do acervo do Instituto Moreira
                Salles. É membro do coletivo Movielas - Mulheres do som e da
                imagem do audiovisual, do Deriva Cartográfica - coletivo de
                fotografia analógica dedicado à troca de filmes e do duo
                criativo Trukera junto com Raíssa Vilela.
              </h5>
              <div>
                <img src={image_1} alt="" className={"img-fluid"} />
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: "5vw", marginBottom: 0 }} className={"px-2"}>
            <Col xs={{ span: 12 }} md={{ span: 6, offset: 3 }}>
              <h1
                style={{
                  fontFamily: "Active Regular",
                  fontWeight: "bold",
                  color: ProjectColors.getInstance().isHighContrast
                    ? ProjectColors.getInstance().White
                    : ProjectColors.getInstance().Orange,
                  textAlign: "justify",
                }}
              >
                "Pra mim casa é isso, quando você tem alguma memória e a luzinha
                passa e você sente aquele brilhinho, aquela sensação de que tá
                tudo bem".
              </h1>
            </Col>
          </Row>

          <Row style={{ marginTop: "5vw" }} className={"px-3"}>
            <Col xs={{ span: 12 }} md={{ span: 10, offset: 1 }}>
              <div>
                <h1
                  className={"mb-4"}
                  style={{
                    fontFamily: "Active Regular",
                    fontWeight: "bold",
                    color: ProjectColors.getInstance().isHighContrast
                      ? ProjectColors.getInstance().White
                      : ProjectColors.getInstance().DarkGreen,
                  }}
                >
                  Em casa
                </h1>
                <video
                  className={"img-fluid"}
                  style={{ justifyContent: "center", display: "flex" }}
                  controls
                  poster={frame_2}
                >
                  <source src={casa_video} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </Col>
          </Row>

          <div
            style={{
              backgroundColor: ProjectColors.getInstance().isHighContrast
                ? ProjectColors.getInstance().Black
                : ProjectColors.getInstance().Green,
              width: "100%",
              marginTop: "5vw",
              paddingTop: "5vw",
            }}
          >
            <Row style={{ marginTop: 10 }} className={"px-2"}>
              <Col xs={{ span: 12 }} sm={{ span: 10, offset: 1 }}>
                <Carousel
                  infiniteLoop
                  showIndicators={false}
                  showStatus={false}
                  autoPlay={false}
                >
                  {[
                    <div>
                      <img src={image_4} />
                    </div>,
                    <div>
                      <img src={mosaico} />
                    </div>,

                    <div>
                      <img src={jornal} />
                    </div>,

                    <div>
                      <img src={image_3} />
                    </div>,
                    <div>
                      <img src={rosa} />
                    </div>,
                  ]}
                </Carousel>
              </Col>
            </Row>
            <Row
              style={{ marginTop: "5vw", paddingBottom: "5vw" }}
              className={"px-3"}
            >
              <Col xs={{ span: 12 }} md={{ span: 10, offset: 1 }}>
                <div>
                  <h1
                    className={"mb-4"}
                    style={{
                      fontFamily: "Active Regular",
                      fontWeight: "bold",
                      color: ProjectColors.getInstance().isHighContrast
                        ? ProjectColors.getInstance().White
                        : ProjectColors.getInstance().DarkGreen,
                    }}
                  >
                    Mulher e espaço doméstico
                  </h1>
                  <video
                    className={"img-fluid"}
                    style={{ justifyContent: "center", display: "flex" }}
                    controls
                    poster={frame_3}
                  >
                    <source src={mulher_video} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
              </Col>
            </Row>
          </div>

          <Row style={{ marginTop: "5vw" }} className={"px-2"}>
            <Col xs={{ span: 12 }}>
              <div
                className={"justify-content-center"}
                style={{ display: "flex" }}
              >
                <img
                  src={houses}
                  alt=""
                  style={{ height: "max(7vw, 70px)", backgroundColor: "white" }}
                />
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: "5vw" }} className={"px-3"}>
            <Col xs={{ span: 12 }} md={{ span: 10, offset: 1 }}>
              <div>
                <h1
                  className={"mb-4"}
                  style={{
                    fontFamily: "Active Regular",
                    fontWeight: "bold",
                    color: ProjectColors.getInstance().isHighContrast
                      ? ProjectColors.getInstance().White
                      : ProjectColors.getInstance().DarkGreen,
                  }}
                >
                  Casa e pandemia
                </h1>
                <video
                  className={"img-fluid m-auto"}
                  style={{ justifyContent: "center", display: "flex" }}
                  controls
                  poster={frame_1}
                >
                  <source src={pandemia_video} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: "5vw" }} className={"px-2"}>
            <Col
              xs={{ span: 12 }}
              md={{ span: 4, offset: 4 }}
              className={"justify-content-center"}
            >
              <div
                style={{ display: "flex" }}
                className={"justify-content-center"}
              >
                <img src={old_house_2} alt="" className={"img-fluid"} />
              </div>
              <div>
                <div style={{ marginTop: 20 }}>
                  <p
                    style={{
                      fontSize: "max(1vw, 15px)",
                      textAlign: "right",
                      color: ProjectColors.getInstance().isHighContrast
                        ? ProjectColors.getInstance().White
                        : ProjectColors.getInstance().Black,
                    }}
                  >
                    {" "}
                    Casa de minha avó e de minha mãe no Guará onde morei
                  </p>
                </div>
              </div>
            </Col>
          </Row>

          <Row
            style={{ marginTop: "5vw", marginBottom: "5vw" }}
            className={"px-3"}
          >
            <Col xs={{ span: 12 }} md={{ span: 10, offset: 1 }}>
              <div>
                <h1
                  className={"mb-4"}
                  style={{
                    fontFamily: "Active Regular",
                    fontWeight: "bold",
                    color: ProjectColors.getInstance().isHighContrast
                      ? ProjectColors.getInstance().White
                      : ProjectColors.getInstance().DarkGreen,
                  }}
                >
                  Processo artístico
                </h1>
                <video
                  className={"img-fluid m-auto"}
                  style={{ justifyContent: "center", display: "flex" }}
                  controls
                  poster={frame_0}
                >
                  <source src={criacao_video} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </Col>
          </Row>

          {/*<Row style={{marginTop: 80}} className={'px-2'}>*/}
          {/*    <Col xs={{span: 12}}>*/}
          {/*        <div>*/}
          {/*            <img src={image_5} alt="" className={'img-fluid'}/>*/}
          {/*        </div>*/}
          {/*    </Col>*/}

          {/*</Row>*/}

          <Row
            style={{
              paddingTop: "5vw",
              paddingBottom: "5vw",
              backgroundColor: ProjectColors.getInstance().isHighContrast
              ? ProjectColors.getInstance().Black
              : ProjectColors.getInstance().Green,
            }}
            className={"px-3"}
          >
            <Col xs={{ span: 12 }} md={{ span: 5, offset: 1 }}>
              <h1
                style={{
                  fontFamily: "Active Regular",
                  fontWeight: "bold",
                  color: ProjectColors.getInstance().isHighContrast
                    ? ProjectColors.getInstance().White
                    : ProjectColors.getInstance().DarkGreen,
                }}
              >
                Conheça os meus trabalhos
              </h1>
              <br />

              <a
                href={"https://www.trukera.com.br"}
                style={{
                  color: ProjectColors.getInstance().isHighContrast
                    ? ProjectColors.getInstance().LightBlue
                    : ProjectColors.getInstance().DarkGreen,
                  fontSize: 28,
                }}
              >
                Trukera
              </a>

              <br />
              <a
                href={"https://youtu.be/tYMj7XJzB5g"}
                style={{
                  color: ProjectColors.getInstance().isHighContrast
                    ? ProjectColors.getInstance().LightBlue
                    : ProjectColors.getInstance().DarkGreen,
                  fontSize: 28,
                }}
              >
                Espuma dos dias
              </a>

              <br />
              <a
                href="https://www.instagram.com/analumene/"
                style={{
                  color: ProjectColors.getInstance().isHighContrast
                    ? ProjectColors.getInstance().LightBlue
                    : ProjectColors.getInstance().DarkGreen,
                  fontSize: 28,
                }}
              >
                Instagram
              </a>
            </Col>

            <Col xs={{ span: 12 }} md={{ span: 5 }}>
              <div>
                <video
                  className={"img-fluid m-auto"}
                  style={{ justifyContent: "center", display: "flex" }}
                  controls
                  poster={frame_4}
                >
                  <source src={arte_video} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </Col>
          </Row>

          <Row
            style={{
              backgroundImage: "url(" + marina + ")",
              backgroundSize: "cover",
              height: 500,
            }}
            className={"px-3"}
          >
            <Col xs={{ span: 12 }} className={"d-flex "}>
              <h1
                className={"mb-4"}
                style={{
                  fontFamily: "Gotham Light",
                  marginLeft: 30,
                  fontSize: "70px",
                  color: "white",
                }}
              >
                Marina
                <img
                  src={Arrow}
                  width={50}
                  onClick={() => navigate("/artist/marina")}
                  alt={"Seta laranja apontando para a direita"}
                />
              </h1>
            </Col>
          </Row>
        </Container>
      </main>
    </>
  );
}
